// menucomponent/MenuItemCard.js
import React from "react";

export default function MenuItemCard({ item, handleItemClick, colorsState, getCartQuantity, addToCart, removeFromCart }) {
  return (
    <article
      className="menu-item-card"
      onClick={() => handleItemClick(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") handleItemClick(item); }}
      aria-label={`${item.name} — ${item.description}`}
    >
      <div className="menu-img-wrap">
        <img src={item.image} alt={item.name} />
      </div>
      <div className="menu-card-body">
        <h4 className="menu-item-title">
          {item.name}
          <span
            className="menu-diet-dot"
            title={item.diet === "veg" ? "Vegetarian" : "Non-vegetarian"}
            aria-hidden="true"
            style={{ background: item.diet === "veg" ? colorsState.veg : colorsState.nonVeg }}
          />
        </h4>
        <p className="menu-desc">{item.description}</p>
        <div className="menu-meta">
          <div className="menu-price">₹ {Number(item.price).toFixed(0)}</div>
          <div className="menu-controls">
            <button
              className="menu-qty-btn"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                removeFromCart(item);
              }}
              aria-label={`Remove ${item.name} from cart`}
            >
              −
            </button>
            <span className="menu-qty">{getCartQuantity(item.name)}</span>
            <button
              className="menu-add-btn"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                addToCart(item);
              }}
              aria-label={`Add ${item.name} to cart`}
            >
              +
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
